module.exports = __webpack_public_path__ + "static/media/riskcase3.eeea35a5.png";